import { GzButtonWebComponent } from './component/GzButtonWebComponent';
import { GzSplitButtonWebComponent } from './component/GzSplitButtonWebComponent';
import { WEB_COMPONENT_GZ_BUTTON, WEB_COMPONENT_GZ_SPLIT_BUTTON } from '../../webcomponents.constants';

export { GzButtonWebComponent, GzSplitButtonWebComponent };

//window.customElements.define(WEB_COMPONENT_GZ_BUTTON, GzButtonWebComponent);
//window.customElements.define(WEB_COMPONENT_GZ_SPLIT_BUTTON, GzSplitButtonWebComponent);

/**
 *  Examples:
 *  Default blue button => <gz-button color="primary">Action</gz-button>
 *
 *  Default blue button disabled => <gz-button color="primary" disabled>Action</gz-button>
 *
 *  Small blue outlined button => <gz-button color="primary" type="outline" buttonheight="small">Action</gz-button>
 *
 *  Secondary small button with small font =>
 *  <gz-button color="secondary" buttonheight="small" buttonfontsize="small">Action</gz-button>
 *
 *  Secondary small button with small lowercase font =>
 *  <gz-button color="secondary" buttonheight="small" buttonfontsize="small" lowercase>Action</gz-button>
 *
 *  Negative quiet button => <gz-button color="negative" type="quiet">Action</gz-button>
 *
 *  Default blue button with icon =>
 *  <gz-button color="primary">Action <span class="icon icon-calendar"></span></gz-button>
 */
